import { Tabs, TabsContent, TabsList, TabsTrigger } from '@sakura-grp/ui/tabs';
import type { CustomerDetailData } from '~/types/customer-detail.types';

export type CustomerDetailTabValue = 'base_cards' | 'branch' | 'announcements' | 'reserve';

interface CustomerDetailTabsProps {
  data: CustomerDetailData;
  baseCardsContent: React.ReactNode;
  branchContent?: React.ReactNode;
  announcementsContent: React.ReactNode;
  reserveContent: React.ReactNode;
  activeTab?: CustomerDetailTabValue;
  onTabChange?: (tab: CustomerDetailTabValue) => void;
}

export const CustomerDetailTabs = ({
  data,
  baseCardsContent,
  branchContent,
  announcementsContent,
  reserveContent,
  activeTab = 'base_cards',
  onTabChange,
}: CustomerDetailTabsProps) => {
  // 枝客タブは担当顧客(assigned)のみ表示
  const showBranchTab = data.type === 'assigned' && data.branches && data.branches.length > 0;

  return (
    <Tabs
      value={activeTab}
      onValueChange={(value) => onTabChange?.(value as CustomerDetailTabValue)}
      className="w-full"
    >
      <TabsList className="px-lg text-lg">
        <TabsTrigger value="base_cards">基本情報＆名刺</TabsTrigger>
        {showBranchTab && (
          <TabsTrigger value="branch">🪾 枝客</TabsTrigger>
        )}
        <TabsTrigger value="announcements">営業履歴</TabsTrigger>
        <TabsTrigger value="reserve">予約履歴</TabsTrigger>
      </TabsList>

      <TabsContent value="base_cards">
        {baseCardsContent}
      </TabsContent>

      {showBranchTab && (
        <TabsContent value="branch">
          {branchContent}
        </TabsContent>
      )}

      <TabsContent value="announcements">
        {announcementsContent}
      </TabsContent>

      <TabsContent value="reserve">
        {reserveContent}
      </TabsContent>
    </Tabs>
  );
};
